module.exports = __webpack_public_path__ + "assets/media/citronniers-desk.00b1aa55.mp4";